<template lang="pug">
  Modal(ref="modal" title="Tree Roots" closable="true")
    .tree-root-modal-body.ssp-form-horizontal
      .parent
        router-link.child.kzcode-default(:to="{ name: 'traceDetails', params: { code: r.code } }" :key="index" v-for="(r, index) in roots") {{ r.code }}
    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  data: () => ({
    roots: null
  }),
  methods: {
    open(roots) {
      this.roots = roots
      this.$refs.modal.open()
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.tree-root-modal-body {
  max-width: 1300px;
  .parent {
    display: flex;
    flex-wrap:wrap;
    max-height: 500px;
    overflow: auto;
  }
  .child {
    min-width: 150px !important;
    margin: 10px;
    flex: 1 0 16%;
  }
  .child:hover {
    text-decoration: underline;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/treerevision/TreeRootsModal.vue